import React from "react";
import CountUp from "react-countup";
import one from "./one.png";
import two from "./two.png";
import a from "./three.png";
import b from "./four.png";
import c from "./five.png";
import MadHighlights from "../mad";

const Header = () => {
  return (
    <>
    <section className="bg-gradient-to-r from-red-700 to-blue-800 text-white py-16 px-4 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        {/* === Feature Cards === */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 justify-items-center">
          
          {/* === Card 1 === */}
          <div className="bg-gradient-to-r from-red-600 to-blue-700 rounded-2xl p-6 text-center transform transition duration-300 hover:-translate-y-2 hover:scale-105 hover:shadow-2xl shadow-black/40 w-full max-w-md">
            {/* Gradient Background for Image */}
            <div className="w-32 h-32 mx-auto mb-4 rounded-full bg-gradient-to-r from-blue-700 to-red-600 flex items-center justify-center shadow-lg shadow-red-600/40 hover:shadow-blue-600/40 transition">
              <img
                src={one}
                alt="Get Certified"
                className="w-20 h-20 object-contain transition-transform duration-300 hover:scale-110"
              />
            </div>

            <h3 className="text-2xl font-bold mb-2">Get certified with MAD</h3>
            <p className="text-gray-100 mb-4">
              Skyrocket your resume. Land your dream job. Stand out from the
              competition.
            </p>
            <button className="font-semibold bg-gradient-to-r from-red-500 to-blue-500 bg-clip-text text-transparent hover:from-blue-500 hover:to-red-500 transition">
  View Job Role Paths →
</button>

          </div>

          {/* === Card 2 === */}
          <div className="bg-gradient-to-r from-blue-700 to-red-600 rounded-2xl p-6 text-center transform transition duration-300 hover:-translate-y-2 hover:scale-105 hover:shadow-2xl shadow-black/40 w-full max-w-md">
            {/* Gradient Background for Image */}
            <div className="w-32 h-32 mx-auto mb-4 rounded-full bg-gradient-to-r from-red-600 to-blue-700 flex items-center justify-center shadow-lg shadow-blue-600/40 hover:shadow-red-600/40 transition">
              <img
                src={two}
                alt="Master Skills"
                className="w-20 h-20 object-contain transition-transform duration-300 hover:scale-110"
              />
            </div>

            <h3 className="text-2xl font-bold mb-2">Master new skills</h3>
            <p className="text-gray-100 mb-4">
              Learn popular offensive and defensive security techniques with
              skill paths.
            </p>
           <button className="font-semibold bg-gradient-to-r from-red-500 to-blue-500 bg-clip-text text-transparent hover:from-blue-500 hover:to-red-500 transition">
  View Skill Paths →
</button>

          </div>
        </div>

        {/* === Stats === */}
        <div className="text-center mt-16">
         <h2 className="text-5xl md:text-6xl font-extrabold bg-gradient-to-r from-red-500 to-blue-500 bg-clip-text text-transparent">
  <CountUp end={2.1} duration={3} decimals={1} />m+
</h2>

          <p className="text-xl mt-3 text-gray-100">
            Learners advancing in cybersecurity.
          </p>
        </div>
      </div>
    </section>
    <MadHighlights/>
    </>
  );
};

export default Header;
